export const SNP_NO_READ_COLOR = "#CCBAFF";
export const SNP_UNTESTED_COLOR = "#E5E5E5";

export default function getSnpColor(value) {
    let color = "dark";
    if (value === 1.0) {
        color = "#FF5D6D";
    } else if (value === 0.5) {
        color = "#FF905F";
    } else if (value === 0) {
        color = "#00BF86";
    }
    return color;
}

export function getSvgSnpColor(value) {
    let color = "dark";
    if (value === 1.0) {
        color = "#FF5D6D";
    } else if (value === 0.5) {
        color = "#FF905F";
    } else if (value === 0) {
        color = "#00BF86";
    }
    return color;
}

export function getSnpImpactSymbol(value, impactActivity, { showCircle = false } = {}) {
    if (value > 0) {
        if (impactActivity === "Increase") {
            return "up-triangle";
        }
        if (impactActivity === "Decrease") {
            return "down-triangle";
        }
        if (showCircle && impactActivity === "Neutral") {
            return "circle";
        }
    }

    return showCircle ? "circle" : null;
}

export function buildDiagramGeneColors(snpsForDiagram = {}, expectedSnps = {}) {
    const geneNames = new Set([
        ...Object.keys(snpsForDiagram || {}),
        ...Object.keys(expectedSnps || {})
    ]);
    const colors = {};

    geneNames.forEach(geneName => {
        const gene = snpsForDiagram?.[geneName];
        const testedSnps = gene?.snps ?? [];
        const expectedNames = expectedSnps?.[geneName] ?? [];
        const testedByName = new Map(testedSnps.map(snp => [snp.name, snp]));
        const snpColor = [];
        const symbol = [];

        if (expectedNames.length > 0) {
            expectedNames.forEach(expectedName => {
                const tested = testedByName.get(expectedName);
                if (tested) {
                    snpColor.push(getSvgSnpColor(tested.value));
                    symbol.push(
                        getSnpImpactSymbol(tested.value, tested.impact_activity ?? tested.impactActivity, {
                            showCircle: true
                        })
                    );
                } else {
                    snpColor.push(SNP_NO_READ_COLOR);
                    symbol.push("circle");
                }
            });
        } else {
            testedSnps.forEach(tested => {
                snpColor.push(getSvgSnpColor(tested.value));
                symbol.push(
                    getSnpImpactSymbol(tested.value, tested.impact_activity ?? tested.impactActivity, {
                        showCircle: true
                    })
                );
            });
        }

        const hasTestedSnps = testedSnps.length > 0;
        const isExpected = expectedNames.length > 0;

        colors[geneName] = {
            lozengeColor: hasTestedSnps
                ? getSvgSnpColor(gene.variance)
                : isExpected
                  ? SNP_NO_READ_COLOR
                  : SNP_UNTESTED_COLOR,
            snpColor,
            symbol
        };
    });

    return colors;
}

export function getApoeGenotypeBadgeColor(interpretation) {
    const normalized = (interpretation ?? "").trim().toLowerCase();

    if (normalized === "e2/e2") {
        return "green";
    }

    if (normalized === "e4/e4") {
        return "red";
    }

    return "orange";
}

export function mapDnaDatapointToSnpRow(datapoint) {
    const value = datapoint?.riskAllele?.value ?? datapoint?.value;

    return {
        title: datapoint?.datapoint?.name,
        accentColor: getSnpColor(value),
        interpretation: datapoint?.snpInterpretation,
        suggestion: datapoint?.snpSuggestion,
        badgeText: datapoint?.riskAllele?.alleles?.join("") ?? datapoint?.interpretation ?? "--",
        symbol: getSnpImpactSymbol(value, datapoint?.impactActivity)
    };
}